module.exports = __webpack_public_path__ + "static/media/ExamAddGray.882b0943.svg";